import { object, string, array, number } from 'valibot';
import { paginationScheme } from '@/shared/schemes/pagination';
import { articleMetricSchema } from '@/entities/Article/api/schemes';

export const schemeSearchData = object({
	...paginationScheme,
	results: array(
		object({
			id: number(),
			title: string(),
			text: string(),
			dictionary_slug: string(),
			...articleMetricSchema,
		}),
	),
});
